<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp1" id="pt1"> </p>
<p class="pn"><span epub:type="pagebreak" id="pg_17" title="17"><span class="ePub-SC">PART I</span></span></p>
<p class="pt">The Progressive Era</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?cd6479b8